import { useSelector } from "react-redux";
import RootState from "../store/state";

const useApp = () => {
    const app = useSelector<RootState, RootState["app"]>(
        state => state.app
    )

    return app;
}

export default useApp;